import React from 'react';
import CTA from "../../../../components/Constant/cta/CTA";
import WhySection from "../../../../components/WhySection/WhySection";
import IntroSection from "../../../../components/IntroSection/IntroSection";
import FAQList from "../../../../components/Constant/FAQCard/FAQCard";
import DetailsSection from "../../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../../components/InfoBlocks/InfoBlocks";
import SEO from "../../../../utils/SEO";

export default function ReadyMadeCompaniesWesternSahara() {

    return (
        <main className='main'>
            <SEO
                title=""
                description=""
                keywords=""
                url="/ready-made-companies-western-sahara"
            />
            <IntroSection
                title="Ready-Made Companies in Western Sahara"
                subtitle="Start Operating Immediately with a CRA-Registered Entity"
                description="Why wait weeks or months to form a company? Offshore Advisory offers ready-made companies already registered under the CRA (Western Sahara), so you can skip the formation process and start operations immediately."
                badges={[
                    "Fully Registered Entity",
                    "Transferable Ownership",
                    "Compliance Ready"
                ]}
                buttonText="Request Available Companies →"
                buttonLink="/quote"
                imageSrc={require('../../../../assets/images/ready-made/ready-made-western-sahara.png')}
                imageAlt="Ready-Made Companies Western Sahara"
            />


            <section className='section'>
                <div className="container">
                    <WhySection
                        title="What Is a Ready-Made Company?"
                        subtitle='A ready-made (or “shelf”) company is an already incorporated entity with legal status, registration, and documentation complete under CRA in Western Sahara. All you need to do is acquire it, update the beneficial ownership/KYC, and start using it for your intended business purpose.'
                    />

                    <WhySection
                        title="Why Choose Ready-Made Companies from Western Sahara?"
                        blocks={[
                            {
                                items: [
                                    { text: "Instant Setup — fully functional company in 24–72 hours." },
                                    { text: "CRA Registered — established under the Western Sahara legal framework." },
                                    { text: "Compliance-Ready — incorporation and registrations already completed." },
                                    { text: "Cost & Time Efficiency — avoid delays and lengthy paperwork." },
                                    { text: "Offshore Flexibility — ideal for fintech, crypto, consulting, trading, and cross-border business models." }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title="What You Get in the Package"
                        subtitle='Each ready-made company package includes:'
                        blocks={[
                            {
                                items: [
                                    { text: "Certificate of Incorporation, Memorandum & Articles of Association." },
                                    { text: "Corporate registers and statutory records." },
                                    { text: "Official documents: share certificates, resolutions, corporate extracts." },
                                    { text: "Digital copies of all registration documents." },
                                    { text: "Transfer documentation for new ownership." },
                                    { text: "KYC takeover setup (client supplies new beneficiary documents)." },
                                    { text: "Optional: nominee director/shareholder arrangements." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="How It Works (Transfer Process)"
                        blocks={[
                            {
                                items: [
                                    { text: "Check Availability & Reserve — we provide a list of ready-made companies." },
                                    { text: "Submit KYC documents — ID, proof of address, business profile." },
                                    { text: "Sign transfer agreements — share assignment, resolutions, PoA." },
                                    { text: "Register the change with CRA and update beneficial ownership." },
                                    { text: "Begin operations — banking, licensing, contracting, invoicing." }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title="Use Cases for Western Sahara Ready-Made Companies"
                        blocks={[
                            {
                                items: [
                                    { text: "Launch gambling, crypto, or fintech ventures quickly under CRA." },
                                    { text: "Start contracting, invoicing, and business operations immediately." },
                                    { text: "Operate affiliate, marketing, or consulting entities without delay." },
                                    { text: "Use as a B2B service entity in regulated/semi-regulated environments." },
                                    { text: "Prepare for license applications with an already established company." }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title="Pricing & Transfer Fees"
                        blocks={[
                            {
                                items: [
                                    { text: "Base price: starting from USD X,XXX (varies by age/history/included services)." },
                                    { text: "KYC / transfer fee: one-time fee for processing ownership transfer." },
                                    { text: "Optional add-ons: nominee services, enhanced compliance, banking setup." },
                                    { text: "📌 All fees are transparent and disclosed upfront." }
                                ]
                            }
                        ]}
                    />


                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                { text: "We maintain an updated portfolio of CRA ready-made companies" },
                                { text: "We handle full transfer, compliance, and documentation" },
                                { text: "Trusted in CRA licensing, corporate setups, and banking integrations" },
                                { text: "Support for bank account setup, licensing, and business launch" }
                            ]
                        }
                        />
                    <CTA
                        title="Need a Western Sahara company ready right now?"
                        description="Skip the wait, avoid red tape, and start operations instantly with a CRA-ready company."
                        buttonText="Request our Available Ready-Made Companies →"
                        buttonLink="/quote"
                    />


                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Are ready-made companies legal under CRA?",
        answer: "Yes — ready-made companies are fully legal as long as you complete the KYC and formal transfer under CRA regulation.",
    },
    {
        question: "How old can a ready-made company be?",
        answer: "Typically 0–3 years. Older companies may raise questions, so fresh ones are preferred.",
    },
    {
        question: "Can I use it for a gaming or crypto license later?",
        answer: "Yes — the company is CRA-registered and compatible with subsequent license applications.",
    },
    {
        question: "How long does the transfer take?",
        answer: "Usually 24–72 hours after KYC and document signing.",
    },
    {
        question: "Do I need a nominee service?",
        answer: "If you prefer privacy or CRA requires a local director/shareholder, we offer nominee services as an add-on.",
    },
];
